import React from 'react';

import DNDComponent, {DNDComponentProps} from './dnd-component';

export type DNDComponent2Props = {
    disableMouseMoveListeners?  : boolean
    disableMouseEnterListeners? : boolean
} & DNDComponentProps

// dnd component without using this.componentEl on setStartPosition this highly improves performance on render (any
// style manipulations are at high performance cost on render)
export default class DNDComponent2<T extends DNDComponent2Props> extends DNDComponent<T> {

    startPosition   : any

    constructor(props: DNDComponent2Props) {
        super(props)
    }

    setStartPosition(position:any) {
        if (position) {
            this.startPosition = {
                x: position.x,
                y: position.y
            }
        }
    }

    getStartPosition() {
        if (!this.startPosition) {
            const { offsetLeft, offsetTop } = this.componentEl;

            this.startPosition = {
                x: offsetLeft ? offsetLeft : 0,
                y: offsetTop ? offsetTop : 0
            }
        }

        return this.startPosition;
    }
}